'use strict';

function BankNotSupported() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_AccountController, _BankController];
  this._analytics = new Analytics();

  this.init = function () {
    this._analytics.pushEvent('virtual-page-view');
    this._analytics.pushEvent('link-bank-check-bank', {
      CheckStatus: ['Not Supported'],
      BankName: [this.presenter.getModelProperty('bankSelected.name')]
    });
    this._$node = $(this.node);
    this._$canadaPostDialog = $('#canada-post-dialog');
    this._$canadaPostDialogButton = this._$node.find('.link-bank__canada-post-link');

    if (this._$canadaPostDialogButton) {
      this._$canadaPostDialogButton.on('click', $.proxy(this._onClickCanadaPostLink, this));
    }
  };

  this.initAllReady = function () {};

  this._onClickCanadaPostLink = function (event) {
    this._$canadaPostDialog.mogo().show();
    return false;
  };

  this.destroy = function () {
    this.removeLastSelectedBank();
    if (this._$canadaPostDialogButton) {
      this._$canadaPostDialogButton.off('click', $.proxy(this._onClickCanadaPostLink, this));
    }
  };
}